import React from 'react'
import SubmitButton from '../SubmitButton'
import LinkActionButton from '../../Buttons/LinkActionButton'
import SubmitSpinner from '../../Spinners/SubmitSpinner'
import * as styles from './_EditButton.scss'
import PropTypes from 'prop-types';

class EditButton extends React.Component {
  static propTypes = {
    startEditing: PropTypes.func,
    stopEditing: PropTypes.func,
    cancelEditing: PropTypes.func,
    editing: PropTypes.bool.isRequired,
    formIsValid: PropTypes.bool,
    submitting: PropTypes.bool
  };

  constructor (props) {
    super(props)
    this.toggleEditing = this.toggleEditing.bind(this)
  }

  toggleEditing () {
    if (this.props.editing) {
      this.props.stopEditing()
    } else {
      this.props.startEditing()
    }
  }

  render () {
    const buttonText = this.props.editing || this.props.submitting ? 'Save' : null
    const isValid = this.props.formIsValid && !this.props.submitting
    return (
      <span>
        { this.props.editing || this.props.submitting
          ? <SubmitButton preventDefault isValid={isValid} onClick={this.toggleEditing} buttonText={buttonText} />
          : <LinkActionButton size={'sm'} onClick={this.toggleEditing} className={styles['no-padding']} title={'Edit'} buttonText='Edit' /> }
        { this.props.editing && !this.props.submitting && <LinkActionButton onClick={this.props.cancelEditing} buttonText='Cancel' /> }
        { this.props.submitting && <SubmitSpinner /> }
      </span>
    )
  }
}

export default (EditButton)
